"use strict";

const BaseModuleSettings = require("./baseModuleSettings");

const IddeModuleSettings = function () {
  const tool = "idde";
  const key = "idde-module";
  const formKey = "idde-module-settings";
  const option = "Illicit Discharge Module";
  const iconClass = "idde";
  const userVariableValidatorClassIdde = "validate-idde-cover-letter-variables";
  const moduleProps = { userVariableValidatorClassIdde };

  const initValidatorFunction = (props) => {
    UserVariableValidator.init(
      Object.keys(props?.idde?.maintenanceNoticeUserTemplate || {}),
      `.${userVariableValidatorClassIdde}`,
    );
  };

  const base = new BaseModuleSettings(
    tool,
    key,
    formKey,
    option,
    iconClass,
    moduleProps,
    initValidatorFunction,
  );

  return {
    ...base,
  };
};

module.exports = IddeModuleSettings();

const UserVariableValidator = require("../../misc/userVariableValidator");
